import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Department } from './types'

export const CREATE_DEPARTMENT: TypedDocumentNode<
  { createDepartment: Department },
  {
    client_id: string
    application_id: string
    name: string
    subtitle?: string | null
    description?: string | null
    image?: string | null
    observations?: string | null
    sort_order?: number | null
  }
> = gql`
  mutation CreateDepartment($client_id: ID!, $application_id: ID!, $name: String!, $subtitle: String, $description: String, $image: String, $observations: String, $sort_order: Int) {
    createDepartment(client_id: $client_id, application_id: $application_id, name: $name, subtitle: $subtitle, description: $description, image: $image, observations: $observations, sort_order: $sort_order) {
      id client_id application_id name subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`

export const UPDATE_DEPARTMENT: TypedDocumentNode<
  { updateDepartment: Department },
  {
    id: string
    name?: string
    subtitle?: string | null
    description?: string | null
    image?: string | null
    observations?: string | null
    sort_order?: number | null
  }
> = gql`
  mutation UpdateDepartment($id: ID!, $name: String, $subtitle: String, $description: String, $image: String, $observations: String, $sort_order: Int) {
    updateDepartment(id: $id, name: $name, subtitle: $subtitle, description: $description, image: $image, observations: $observations, sort_order: $sort_order) {
      id client_id application_id name subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`

export const DELETE_DEPARTMENT: TypedDocumentNode<{ deleteDepartment: boolean }, { id: string }> =
  gql`
  mutation DeleteDepartment($id: ID!) {
    deleteDepartment(id: $id)
  }
`
